(() => {
  const id = "xencms:paragraph--faq";

  Drupal.behaviors[id] = { attach: (context, settings) => {
    once(id, ".paragraph--faq", context).forEach((faq) => {
      const items = faq.querySelectorAll(".paragraph--faq-item");

      items.forEach(item => {
        item.addEventListener("click", () => {
          item.classList.toggle("is-active");
        });

        // Don't collapse when clicking answer
        item.querySelectorAll(".field--faq-item-answer").forEach(answer => {
          answer.addEventListener("click", event => event.stopPropagation());
        })
      });
    });
  }};
})();
